import Vue from "vue";
import Router from 'vue-router'

// 在路由跳转的时候同一个路由多次添加是不被允许的
// 重写路由的push方法
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
Vue.use(Router);

/**
 * meta内容说明
 * id 该路由对应的菜单id
 * breadcrumb 该路由对应页面展示的面包屑
 */
let routes = [{
    path: '/',
    redirect: '/frame',
    children: []
},
{
    path: '/login',
    name: 'login',
    component: r => require.ensure([], () => r(require('@/page/login/login.vue')), 'login'),
    children: []
},
{
    path: '/agreement',
    name: 'agreement',
    component: r => require.ensure([], () => r(require('@/page/login/agreement.vue')), 'login'),
    children: []
},
{
    path: '/h5/channel/register',
    name: 'h5ChannelRegister',
    component: r => require.ensure([], () => r(require('@/page/h5/channel/register.vue')), 'h5'),
    meta: { title: '渠道注册', noAuth: true },
    children: []
},
{
    path: '/404',
    name: '404',
    component: r => require.ensure([], () => r(require('@/page/public/404.vue')), 'public'),
    children: []
},
{
    path: '/frame',
    name: 'frame',
    component: r => require.ensure([], () => r(require('@/page/frame/frame.vue')), 'frame'),
    children: [
        { //文旅-散客下单
            path: '/fitOrder',
            name: 'fitOrder',
            meta: { id: 126 },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/order/fitCreateOrder.vue')), 'business_lvyou'),
            children: []
        },

        { // 平台下单
            path: '/orderForm',
            name: 'orderForm',
            meta: { id: 31 },
            component: r => require.ensure([], () => r(require('@/page/orderForm/orderForm.vue')), 'orderForm'),
            children: []
        },
        { // 平台下单Channel2定制版
            path: '/orderFormByChannel2',
            name: 'orderFormByChannel2',
            meta: { id: 31 },
            component: r => require.ensure([], () => r(require('@/page/orderForm/orderFormByChannel2.vue')), 'orderFormByChannel2'),
            children: []
        },

        { // 平台下单Channel3定制版
            path: '/orderFormByChannel3',
            name: 'orderFormByChannel3',
            meta: { id: 31 },
            component: r => require.ensure([], () => r(require('@/page/orderForm/orderFormByChannel3.vue')), 'orderFormByChannel3'),
            children: []
        },
        { // 平台下单Channel3定制版
            path: '/orderReturn',
            name: 'orderReturn',
            meta: { id: 78 },
            component: r => require.ensure([], () => r(require('@/page/order/line/orderReturn.vue')), 'orderReturn'),
            children: []
        },
        { // 顺风车代客下单
            path: '/orderFormHitchRide',
            name: 'orderFormHitchRide',
            meta: { id: 31 },
            component: r => require.ensure([], () => r(require('@/page/orderForm/orderFormHitchRide.vue')), 'orderFormHitchRide'),
            children: []
        },


        { // 数据分析-数据概览
            path: '/dataOverview',
            name: 'dataOverview',
            meta: { id: 135 },
            component: r => require.ensure([], () => r(require('@/page/dataAnalysis/overview/overview.vue')), 'dataAnalysis'),
            children: []
        },
        { // 数据分析-车辆分析
            path: '/vehicleAnalysis',
            name: 'vehicleAnalysis',
            meta: { id: 136 },
            component: r => require.ensure([], () => r(require('@/page/dataAnalysis/vehicle/vehicleAnalysis.vue')), 'dataAnalysis'),
            children: []
        },
        { // 数据分析-订单分析
            path: '/orderAnalysis',
            name: 'orderAnalysis',
            meta: { id: 137 },
            component: r => require.ensure([], () => r(require('@/page/dataAnalysis/order/orderAnalysis.vue')), 'dataAnalysis'),
            children: []
        },
        { // 数据分析-司机分析
            path: '/driverAnalysis',
            name: 'driverAnalysis',
            meta: { id: 138 },
            component: r => require.ensure([], () => r(require('@/page/dataAnalysis/driver/driverAnalysis.vue')), 'dataAnalysis'),
            children: []
        },
        { // 数据分析-营收分析
            path: '/revenueAnalysis',
            name: 'revenueAnalysis',
            meta: { id: 139 },
            component: r => require.ensure([], () => r(require('@/page/dataAnalysis/revenue/revenueAnalysis.vue')), 'dataAnalysis'),
            children: []
        },
        { // 数据分析-用户行为分析（小程序埋点统计）
            path: '/userBehaviorAnalysis',
            name: 'userBehaviorAnalysis',
            meta: { id: 221 },
            component: r => require.ensure([], () => r(require('@/page/dataAnalysis/userBehavior/userBehaviorAnalysis.vue')), 'dataAnalysis'),
            children: []
        },

        { // 统计分析-平台数据
            path: '/hitchRideOrderStatistics',
            name: 'hitchRideOrderStatistics',
            meta: { id: 103 },
            component: r => require.ensure([], () => r(require('@/page/operationData/platformData/platformData.vue')), 'hitchRideOrderStatistics'),
            children: []
        },
        { // 统计分析-运营数据
            path: '/operationData',
            name: 'operationData',
            meta: { id: 41 },
            component: r => require.ensure([], () => r(require('@/page/operationData/operationData.vue')), 'operationData'),
            children: []
        },
        { // 统计分析-车辆数据
            path: '/vehicleFlowing',
            name: 'vehicleFlowing',
            meta: { id: 40 },
            component: r => require.ensure([], () => r(require('@/page/operationData/vehicleFlowing.vue')), 'vehicleFlowing'),
            children: []
        },
        { // 统计分析-司机数据
            path: '/driverFlowing',
            name: 'driverFlowing',
            meta: { id: 35 },
            component: r => require.ensure([], () => r(require('@/page/operationData/driverFlowing.vue')), 'driverFlowing'),
            children: []
        },
        { // 统计分析-增强统计分析
            path: '/analysisStatistics',
            name: 'analysisStatistics',
            meta: { id: 212 },
            component: r => require.ensure([], () => r(require('../page/workbench/analysisStatistics.vue')), 'analysisStatistics'),
            children: []
        },

        { // 运营中心-专线调度
            path: '/dispatchCustomize',
            name: 'dispatchCustomize',
            meta: { id: 24 },
            component: r => require.ensure([], () => r(require('@/page/operation/dispatchCustomize.vue')), 'dispatchCustomize'),
            children: []
        },

        { // 运营中心-班次调度
            path: '/schedulingDispatch',
            name: 'schedulingDispatch',
            meta: { id: 120 },
            component: r => require.ensure([], () => r(require('@/page/operation/schedulingDispatch/schedulingDispatch.vue')), 'dispatchLine'),
            children: []
        },
        { // 运营中心-班线调度
            path: '/dispatchLine',
            name: 'dispatchLine',
            meta: { id: 51 },
            component: r => require.ensure([], () => r(require('@/page/operation/dispatchLine.vue')), 'dispatchLine'),
            children: []
        },
        { // 运营中心-班线调度
            path: '/occupySeat',
            name: 'occupySeat',
            meta: { id: 82 },
            component: r => require.ensure([], () => r(require('@/page/operation/occupySeat.vue')), 'occupySeat'),
            children: []
        },

        {
            path: '/passenger',
            name: 'passenger',
            meta: { id: 5 },
            component: r => require.ensure([], () => r(require('@/page/resource/passenger.vue')), 'passenger'),
            children: []
        },
        {
            path: '/securityInspector',
            name: 'securityInspector',
            meta: { id: 50 },
            component: r => require.ensure([], () => r(require('@/page/resource/securityInspector/securityInspector.vue')), 'securityInspector'),
            children: []
        },
        { // 业务管理-数据备份
            path: '/systemBackups',
            name: 'systemBackups',
            meta: { id: 54 },
            component: r => require.ensure([], () => r(require('@/page/resource/systemBackups.vue')), 'systemBackups'),
            children: []
        },
        {
            path: '/securityInspectorDetail',
            name: 'securityInspectorDetail',
            meta: { id: 50, breadcrumb: [{ name: '安全检查', path: '/securityInspector' }, { name: '检查信息' }] },
            component: r => require.ensure([], () => r(require('@/page/resource/securityInspector/securityInspectorDetail.vue')), 'securityInspector'),
            children: []
        },
        {
            path: '/driver',
            name: 'driver',
            meta: { id: 6 },
            component: r => require.ensure([], () => r(require('@/page/resource/driver/list/list.vue')), 'driver'),
            children: []
        },
        {
            path: '/createDriver',
            name: 'createDriver',
            meta: { id: 6, breadcrumb: [{ name: '司机资源', path: '/driver' }, { name: '创建司机' }] },
            component: r => require.ensure([], () => r(require('@/page/resource/driver/create/create.vue')), 'driver'),
            children: []
        },
        {
            path: '/driverDetail',
            name: 'driverDetail',
            meta: { id: 6, breadcrumb: [{ name: '司机资源', path: '/driver' }, { name: '司机信息' }] },
            component: r => require.ensure([], () => r(require('@/page/resource/driver/detail/detail.vue')), 'driver'),
            children: []
        },

        {
            path: '/vehicle',
            name: 'vehicle',
            meta: { id: 7 },
            component: r => require.ensure([], () => r(require('@/page/resource/vehicle/list/list.vue')), 'vehicle'),
            children: []
        },
        {
            path: '/vehicleCreate',
            name: 'vehicleCreate',
            meta: { id: 7, breadcrumb: [{ name: '车辆资源', path: '/vehicle' }, { name: '创建车辆' }] },
            component: r => require.ensure([], () => r(require('@/page/resource/vehicle/create/create.vue')), 'vehicle'),
            children: []
        },
        {
            path: '/vehicleDetail',
            name: 'vehicleDetail',
            meta: { id: 7, breadcrumb: [{ name: '车辆资源', path: '/vehicle' }, { name: '车辆信息' }] },
            component: r => require.ensure([], () => r(require('@/page/resource/vehicle/detail/detail.vue')), 'vehicle'),
            children: []
        },
        {
            path: '/feedback',
            name: 'feedback',
            meta: { id: 13 },
            component: r => require.ensure([], () => r(require('@/page/operation/feedback.vue')), 'feedback'),
            children: []
        },
        {
            path: '/hitchRideOrderDispatch',
            name: 'hitchRideOrderDispatch',
            meta: { id: 95 },
            component: r => require.ensure([], () => r(require('@/page/order/hitchRideOrderDispatch/hitchRideOrderDispatch.vue')), 'hitchRideOrderDispatch'),
            children: []
        },
        {
            path: '/hitchRideOrderHistory',
            name: 'hitchRideOrderHistory',
            meta: { id: 102 },
            component: r => require.ensure([], () => r(require('@/page/order/hitchRideOrderHistory/hitchRideOrderHistory.vue')), 'hitchRideOrderHistory'),
            children: []
        },
        {
            path: '/hitchRideOrderVirtual',
            name: 'hitchRideOrderVirtual',
            meta: { id: 106 },
            component: r => require.ensure([], () => r(require('@/page/order/virtualOrder/virtualOrder.vue')), 'hitchRideOrderVirtual'),
            children: []
        },
        {
            path: '/hitchRideDriverFeedback',
            name: 'hitchRideDriverFeedback',
            meta: { id: 105 },
            component: r => require.ensure([], () => r(require('@/page/order/userFeedback/frame.vue')), 'hitchRideDriverFeedback'),
            children: []
        },
        { // 订单管理（组件级Tab，不再使用子路由）
            path: '/order',
            name: 'order',
            meta: { id: 52 },
            component: r => require.ensure([], () => r(require('@/page/order/orderTabs.vue')), 'order'),
            children: []
        },

        { // 工单管理
            path: '/orderDriver',
            name: 'orderDriver',
            meta: { id: 53 },
            component: r => require.ensure([], () => r(require('@/page/orderDriver/orderDriverTabs.vue')), 'orderDriver'),
            children: [
                { // 专线工单
                    path: '/orderDriverCustomize',
                    name: 'orderDriverCustomize',
                    meta: { id: 16, pid: 53 },
                    component: r => require.ensure([], () => r(require('@/page/orderDriver/customize/orderDriverCustomize.vue')), 'orderDriver'),
                    children: []
                },
                { // 班线工单
                    path: '/orderDriverLine',
                    name: 'orderDriverLine',
                    meta: { id: 55, pid: 53 },
                    component: r => require.ensure([], () => r(require('@/page/orderDriver/line/orderDriverLine.vue')), 'orderDriver'),
                    children: []
                },
                { // 旅游包车工单
                    path: '/orderHitchhikingWork',
                    name: 'orderHitchhikingWork',
                    meta: { id: 89, pid: 53 },
                    component: r => require.ensure([], () => r(require('@/page/orderDriver/orderHitchhikingWork/orderHitchhikingWork.vue')), 'orderDriver'),
                    children: []
                },
                { // 场站工单
                    path: '/czOrderDriver',
                    name: 'czOrderDriver',
                    meta: { id: 112, pid: 53 },
                    component: r => require.ensure([], () => r(require('@/page/business_changzhan/operate/workOrder/workOrder.vue')), 'orderDriver'),
                    children: []
                },
            ]
        },
        { // 客诉工单
            path: '/hitchRideWork',
            name: 'hitchRideWork',
            meta: { id: 130, pid: 2 },
            component: r => require.ensure([], () => r(require('@/page/order/orderHitchhiking/customerWorkOrder.vue')), 'orderDriver'),
            children: []
        },
        { // 客诉工单详情
            path: '/hitchRideWorkDetail',
            name: 'hitchRideWorkDetail',
            meta: { id: 130, breadcrumb: [{ name: '客诉工单', path: '/hitchRideWork' }, { name: '工单详情' }]  },
            component: r => require.ensure([], () => r(require('@/page/order/orderHitchhiking/customerWorkOrderDetail.vue')), 'orderDriver'),
            children: []
        },

        {
            path: '/station',
            name: 'station',
            meta: { id: 77 },
            component: r => require.ensure([], () => r(require('@/page/operation/station/station.vue')), 'station'),
            children: []
        },
        { // 财务中心
            path: '/financial',
            name: 'financial',
            meta: { id: 17 },
            component: r => require.ensure([], () => r(require('@/page/financial/financeTabs.vue')), 'financial'),
            children: [
                { // 专线订单
                    path: '/financialCustomize',
                    name: 'financialCustomize',
                    meta: { id: 17 },
                    component: r => require.ensure([], () => r(require('@/page/financial/financialCustomize.vue')), 'financial'),
                    children: []
                },
                { // 旅游包车
                    path: '/financialChartered',
                    name: 'financialChartered',
                    meta: { id: 17 },
                    component: r => require.ensure([], () => r(require('@/page/financial/financialChartered.vue')), 'financial'),
                    children: []
                },
                { // 专线包车
                    path: '/financialCustomizeChartered',
                    name: 'financialCustomizeChartered',
                    meta: { id: 17 },
                    component: r => require.ensure([], () => r(require('@/page/financial/financialCustomizeChartered.vue')), 'financial'),
                    children: []
                },
                { // 班线订单
                    path: '/financialLine',
                    name: 'financialLine',
                    meta: { id: 17 },
                    component: r => require.ensure([], () => r(require('@/page/financial/financialLine.vue')), 'financial'),
                    children: []
                },
                { // 班线订单
                    path: '/financeFlowingHitchRide',
                    name: 'financeFlowingHitchRide',
                    meta: { id: 17 },
                    component: r => require.ensure([], () => r(require('@/page/financial/financeFlowingHitchRide.vue')), 'financial'),
                    children: []
                },
                { // 场站订单
                    path: '/czOrderFlowing',
                    name: 'czOrderFlowing',
                    meta: { id: 113 },
                    component: r => require.ensure([], () => r(require('@/page/business_changzhan/financial/financial/financeFlowing.vue')), 'financial'),
                    children: []
                },
                { // 场站订单
                    path: '/financialLvYou',
                    name: 'financialLvYou',
                    meta: { id: 129 },
                    component: r => require.ensure([], () => r(require('@/page/financial/financialLvYou.vue')), 'financial'),
                    children: []
                },

            ]
        },
        { // 财务中心-发票管理
            path: '/invoice',
            name: 'invoice',
            meta: { id: 29 },
            component: r => require.ensure([], () => r(require('@/page/financial/invoice.vue')), 'financial'),
            children: []
        },
        { // 财务中心-公司钱包
            path: '/organizationFlowing',
            name: 'organizationFlowing',
            meta: { id: 33 },
            component: r => require.ensure([], () => r(require('@/page/financial/organizationFlowing.vue')), 'financial'),
            children: []
        },

        { // 财务中心-售票统计
            path: '/ticketStatistics',
            name: 'ticketStatistics',
            meta: { id: 76 },
            component: r => require.ensure([], () => r(require('@/page/financial/ticketStatistics.vue')), 'financial'),
            children: []
        },
        { // 财务中心-结算管理
            path: '/stationSettle',
            name: 'stationSettle',
            meta: { id: 80 },
            component: r => require.ensure([], () => r(require('@/page/financial/stationSettle.vue')), 'financial'),
            children: []
        },
        { // 财务中心-安检统计
            path: '/inspectStatistics',
            name: 'inspectStatistics',
            meta: { id: 81 },
            component: r => require.ensure([], () => r(require('@/page/financial/inspectStatistics.vue')), 'financial'),
            children: []
        },
        { // 财务中心-安检统计
            path: '/stationReferrerSettle',
            name: 'stationReferrerSettle',
            meta: { id: 84 },
            component: r => require.ensure([], () => r(require('@/page/financial/stationReferrerSettle.vue')), 'financial'),
            children: []
        },
        { // 运营中心-司机审核
            path: '/driverAudit',
            name: 'driverAudit',
            meta: { id: 18 },
            component: r => require.ensure([], () => r(require('@/page/operation/audit/driverAudit.vue')), 'auditFrame'),
            children: []
        },
        { // 运营中心-司机审核详情
            path: '/driverAuditDetail',
            name: 'driverAuditDetail',
            meta: { id: 18, breadcrumb: [{ name: '司机审核', path: '/driverAudit' }, { name: '审核详情' }] },
            component: r => require.ensure([], () => r(require('@/page/operation/audit/driverAuditDetail.vue')), 'auditFrame'),
            children: []
        },
        { // 财务中心-结算审核
            path: '/settlement',
            name: 'settlement',
            meta: { id: 34 },
            component: r => require.ensure([], () => r(require('@/page/operation/audit/settlement.vue')), 'auditFrame'),
            children: []
        },
        { // 财务中心-结算审核
            path: '/airportAccountSettle',
            name: 'airportAccountSettle',
            meta: { id: 119 },
            component: r => require.ensure([], () => r(require('@/page/business_changzhan/financial/settlement/settlement.vue')), 'auditFrame'),
            children: []
        },
        { // 财务中心-机构账单
            path: '/organizationHitchRideBill',
            name: 'organizationHitchRideBill',
            meta: { id: 108 },
            component: r => require.ensure([], () => r(require('@/page/financial/institutionalBilling.vue')), 'organizationHitchRideBill'),
            children: []
        },
        { // 财务中心-票据管理
            path: '/ticketManage',
            name: 'ticketManage',
            meta: { id: 73 },
            component: r => require.ensure([], () => r(require('@/page/ticketManage/ticketManageTabs.vue')), 'ticketManageTabs'),
            children: [
                { // 票据入库
                    path: '/ticketManagePush',
                    name: 'ticketManagePush',
                    meta: { id: 74, pid: 73 },
                    component: r => require.ensure([], () => r(require('@/page/ticketManage/ticketManagePush')), 'ticketManageTabs'),
                    children: []
                },
                { // 票据领取
                    path: '/ticketManageGet',
                    name: 'ticketManageGet',
                    meta: { id: 75, pid: 73 },
                    component: r => require.ensure([], () => r(require('@/page/ticketManage/ticketManageGet')), 'ticketManageTabs'),
                    children: []
                },
            ]
        },
        { // 业务管理
            path: '/settingFrame',
            name: 'settingFrame',
            meta: { id: 9 },
            // redirect: '/platform',
            component: r => require.ensure([], () => r(require('@/page/business/setting/settingFrame.vue')), 'settingFrame'),
            children: [
                { // 平台管理
                    path: '/platform',
                    name: 'platform',
                    meta: { id: 9 },
                    component: r => require.ensure([], () => r(require('@/page/business/setting/platform.vue')), 'settingFrame'),
                    children: []
                },
                { // 司机管理
                    path: '/driverPort',
                    name: 'driverPort',
                    meta: { id: 9 },
                    component: r => require.ensure([], () => r(require('@/page/business/setting/driverPort.vue')), 'settingFrame'),
                    children: []
                },
                { // 乘客管理
                    path: '/passengerPort',
                    name: 'passengerPort',
                    meta: { id: 9 },
                    component: r => require.ensure([], () => r(require('@/page/business/setting/passengerPort/passengerPort.vue')), 'settingFrame'),
                    children: []
                },
                { // 票务配置
                    path: '/ticketing',
                    name: 'ticketing',
                    meta: { id: 9 },
                    component: r => require.ensure([], () => r(require('@/page/business/setting/ticketing.vue')), 'settingFrame'),
                    children: []
                },
                { // 座位排版
                    path: '/seat',
                    name: 'seat',
                    meta: { id: 9 },
                    component: r => require.ensure([], () => r(require('@/page/business/setting/seat.vue')), 'settingFrame'),
                    children: []
                },
                { // 协议管理
                    path: '/protocol',
                    name: 'protocol',
                    meta: { id: 9 },
                    component: r => require.ensure([], () => r(require('@/page/business/setting/protocol.vue')), 'settingFrame'),
                    children: []
                },

                { // 包车业务
                    path: '/chartered',
                    name: 'chartered',
                    meta: { id: 9 },
                    component: r => require.ensure([], () => r(require('@/page/business/setting/chartered.vue')), 'settingFrame'),
                    children: []
                },
                { // 下单区域限制
                    path: '/regionalRestrictions',
                    name: 'regionalRestrictions',
                    meta: { id: 9 },
                    component: r => require.ensure([], () => r(require('@/page/business/setting/regionalRestrictions.vue')), 'settingFrame'),
                    children: []
                },
                { // 司机数据备份详情
                    path: '/driverFormBackup',
                    name: 'driverFormBackup',
                    meta: { id: 9, breadcrumb: [{ name: '数据备份', path: '/dataBackup' }, { name: '司机数据备份' }] },
                    component: r => require.ensure([], () => r(require('@/page/resource/driver/driverFormBackup.vue')), 'dataBackup'),
                    children: []
                },
                { // 车辆数据备份详情
                    path: '/vehicleFormBackup',
                    name: 'vehicleFormBackup',
                    meta: { id: 9, breadcrumb: [{ name: '数据备份', path: '/dataBackup' }, { name: '车辆数据备份' }] },
                    component: r => require.ensure([], () => r(require('@/page/resource/vehicle/vehicleFormBackup.vue')), 'dataBackup'),
                    children: []
                },
                { // 敏感人员数据
                    path: '/sensitivePersonnel',
                    name: 'sensitivePersonnel',
                    meta: { id: 9 },
                    component: r => require.ensure([], () => r(require('@/page/business/setting/sensitivePersonnel.vue')), 'settingFrame'),
                    children: []
                },
                { // 司机端通知
                    path: '/notification',
                    name: 'Notification',
                    meta: { id: 9 },
                    component: r => require.ensure([], () => r(require('@/page/operation/audit/notification.vue')), 'auditFrame'),
                    children: []
                },
                { // 培训计划
                    path: '/training',
                    name: 'training',
                    meta: { id: 9 },
                    component: r => require.ensure([], () => r(require('@/page/resource/training.vue')), 'training'),
                    children: []
                },
                { // 安检模板管理
                    path: '/securityTemplate',
                    name: 'securityTemplate',
                    meta: { id: 9 },
                    component: r => require.ensure([], () => r(require('@/page/business/setting/securityTemplate.vue')), 'settingFrame'),
                    children: []
                },
                { // 安检模板管理
                    path: '/orderStationSettle',
                    name: 'orderStationSettle',
                    meta: { id: 9 },
                    component: r => require.ensure([], () => r(require('@/page/business/setting/orderStationSettle.vue')), 'settingFrame'),
                    children: []
                },
                { // 安检模板管理
                    path: '/stationReferrerConfig',
                    name: 'stationReferrerConfig',
                    meta: { id: 9 },
                    component: r => require.ensure([], () => r(require('@/page/business/setting/stationReferrerConfig.vue')), 'settingFrame'),
                    children: []
                },
            ]
        },
        { // 旅游包车独立模块（一级菜单入口，重定向到包车订单）
            path: '/charteredModule',
            name: 'charteredModule',
            meta: { id: 211 },
            component: r => require.ensure([], () => r(require('@/page/chartered/charteredFrame.vue')), 'chartered'),
            children: []
        },
        { // 旅游包车 - 包车订单
            path: '/charteredOrder',
            name: 'charteredOrder',
            meta: { id: 216 },
            component: r => require.ensure([], () => r(require('@/page/chartered/charteredOrder.vue')), 'chartered'),
            children: []
        },
        { // 旅游包车 - 包车工单
            path: '/charteredWork',
            name: 'charteredWork',
            meta: { id: 217 },
            component: r => require.ensure([], () => r(require('@/page/chartered/charteredWork.vue')), 'chartered'),
            children: []
        },
        { // 旅游包车 - 包车财务
            path: '/charteredFinancial',
            name: 'charteredFinancial',
            meta: { id: 218 },
            component: r => require.ensure([], () => r(require('@/page/chartered/charteredFinancial.vue')), 'chartered'),
            children: []
        },
        { // 旅游包车 - 包车设置
            path: '/charteredSetting',
            name: 'charteredSetting',
            meta: { id: 219 },
            component: r => require.ensure([], () => r(require('@/page/chartered/charteredSetting.vue')), 'chartered'),
            children: []
        },
        { // 旅游包车 - 数据统计
            path: '/charteredStatistics',
            name: 'charteredStatistics',
            meta: { id: 220 },
            component: r => require.ensure([], () => r(require('@/page/chartered/charteredStatistics.vue')), 'chartered'),
            children: []
        },
        { // 协议详情
            path: '/protocolDetail',
            name: 'protocolDetail',
            meta: { id: 9, breadcrumb: [{ name: '协议管理', path: '/protocol' }, { name: '协议详情' }] },
            component: r => require.ensure([], () => r(require('@/page/business/setting/protocolDetail.vue')), 'settingFrame'),
            children: []
        },
        // 抢单配置
        {
            path: '/hitchRideAutoAccept',
            name: 'hitchRideAutoAccept',
            meta: { id: 121 },
            component: r => require.ensure([], () => r(require('@/page/business/grabOrders/index.vue')), 'hitchRideAutoAccept'),
            children: []
        },

        { //规则管理
            path: '/rulesConfig',
            name: 'rulesConfig',
            meta: { id: 99 },
            component: r => require.ensure([], () => r(require('@/page/business/rules/rules.vue')), 'rulesConfig'),
            children: [
                { // 计价
                    path: '/hitchRidePricingRule',
                    name: 'hitchRidePricingRule',
                    meta: { id: 85 },
                    component: r => require.ensure([], () => r(require('@/page/business/rules/hitchRidePricingRule.vue')), 'rulesConfig'),
                    children: []
                },
                { // 销单
                    path: '/hitchRideCancelRule',
                    name: 'hitchRideCancelRule',
                    meta: { id: 100 },
                    component: r => require.ensure([], () => r(require('@/page/business/rules/hitchRideCancelRule.vue')), 'rulesConfig'),
                    children: []
                },
                { // 抽成
                    path: '/hitchRideSettleRule',
                    name: 'hitchRideSettleRule',
                    meta: { id: 94 },
                    component: r => require.ensure([], () => r(require('@/page/business/rules/hitchRideSettleRule.vue')), 'rulesConfig'),
                    children: []
                },
                { // 场站抽成
                    path: '/airportCommissionRule',
                    name: 'czHitchRideSettleRule',
                    meta: { id: 94 },
                    component: r => require.ensure([], () => r(require('@/page/business_changzhan/business/rules/rake.vue')), 'rulesConfig'),
                    children: []
                },

                { // 提现
                    path: '/hitchRideWithdrawalRule',
                    name: 'hitchRideWithdrawalRule',
                    meta: { id: 101 },
                    component: r => require.ensure([], () => r(require('@/page/business/rules/hitchRideWithdrawalRule.vue')), 'rulesConfig'),
                    children: []
                },
                { // 车主认证
                    path: '/hitchRideDriverAuditRule',
                    name: 'hitchRideDriverAuditRule',
                    meta: { id: 104 },
                    component: r => require.ensure([], () => r(require('@/page/business/rules/hitchRideDriverAuditRule.vue')), 'rulesConfig'),
                    children: []
                },
                { // 场站司机提现
                    path: '/driverWithdrawalRule',
                    name: 'driverWithdrawalRule',
                    meta: { id: 118 },
                    component: r => require.ensure([], () => r(require('@/page/business_changzhan/business/rules/driverWithdrawalRule.vue')), 'rulesConfig'),
                    children: []
                },
                { // 场站业务提现
                    path: '/dispatchWithdrawalRule',
                    name: 'dispatchWithdrawalRule',
                    meta: { id: 117 },
                    component: r => require.ensure([], () => r(require('@/page/business_changzhan/business/rules/dispatchWithdrawalRule.vue')), 'rulesConfig'),
                    children: []
                },
            ]
        },

        { // 业务管理-提成规则
            path: '/commission',
            name: 'commission',
            meta: { id: 20 },
            component: r => require.ensure([], () => r(require('@/page/business/commission/commission.vue')), 'commission'),
            children: []
        },
        { // 资源管理-车主审核
            path: '/vehicleAudit',
            name: 'vehicleAudit',
            meta: { id: 87 },
            // component: r => require.ensure([], () => r(require('@/page/resource/vehicleAudit/vehicleAudit.vue')), 'vehicleAudit'),
            component: r => require.ensure([], () => r(require('@/page/operation/audit/sfxDriverAudit.vue')), 'vehicleAudit'),
            children: []
        },
        { // 资源管理-车辆审核
            path: '/driverChannel',
            name: 'driverChannel',
            meta: { id: 93 },
            component: r => require.ensure([], () => r(require('@/page/resource/driverChannel/driverChannel.vue')), 'driverChannel'),
            children: []
        },

        { // 资源管理-车辆审核
            path: '/driverChannelData',
            name: 'driverChannelData',
            meta: { id: 93, breadcrumb: [{ name: '渠道资源', path: '/driverChannel' }, { name: '渠道数据' }] },
            component: r => require.ensure([], () => r(require('@/page/resource/driverChannel/driverChannelData.vue')), 'driverChannel'),
            children: []
        },




        { // 排班管理
            path: '/scheduling',
            name: 'scheduling',
            meta: { id: 27 },
            component: r => require.ensure([], () => r(require('@/page/scheduling/schedulingTabs.vue')), 'schedulingTabs'),
            children: [
                { // 排班管理 - 定制客运
                    path: '/customize',
                    name: 'customize',
                    meta: { id: 65, pid: 27 },
                    component: r => require.ensure([], () => r(require('@/page/scheduling/customize/customize.vue')), 'customize'),
                    children: []
                },

                    { // 排班管理 - 班线客运
                        path: '/line',
                        name: 'line',
                        meta: {id: 66, pid: 27},
                        component: r => require.ensure([], () => r(require('@/page/scheduling/line/line.vue')), 'line'),
                        children: []
                    },

                ]
            },
            { // 排班管理 - 定制客运
                path: '/customizeDetail',
                name: 'customizeDetail',
                meta: { id: 65, breadcrumb: [{ name: '线路排班', path: '/customize' }, { name: '线路详情' }] },
                component: r => require.ensure([], () => r(require('@/page/scheduling/customize/detail/detail.vue')), 'customize'),
                children: []
            },

        { // 活动管理
            path: '/activity',
            name: 'activity',
            meta: { id: 91 },
            component: r => require.ensure([], () => r(require('@/page/business/activity/activity.vue')), 'schedulingTabs'),
            children: [
                { // 活动管理 - 拉新活动
                    path: '/invitation',
                    name: 'invitation',
                    meta: { id: 92, pid: 91 },
                    component: r => require.ensure([], () => r(require('@/page/business/activity/invitation.vue')), 'customize'),
                    children: []
                },

                { // 活动管理 - 拉新活动
                    path: '/chargeOrder',
                    name: 'chargeOrder',
                    meta: { id: 96, pid: 91 },
                    component: r => require.ensure([], () => r(require('@/page/business/activity/chargeOrder.vue')), 'customize'),
                    children: []
                },

            ]
        },
        { // 活动管理 - 拉新活动
            path: '/invitationForm',
            name: 'invitationForm',
            meta: { id: 91, breadcrumb: [{ name: '司机拉新', path: '/invitation' }, { name: '创建活动' }] },
            component: r => require.ensure([], () => r(require('@/page/business/activity/invitationForm.vue')), 'customize'),
            children: []
        },
        { // 活动管理 - 拉新活动
            path: '/chargeOrderForm',
            name: 'chargeOrderForm',
            meta: { id: 91, breadcrumb: [{ name: '首单奖励', path: '/chargeOrder' }, { name: '创建活动' }] },
            component: r => require.ensure([], () => r(require('@/page/business/activity/chargeOrderForm.vue')), 'customize'),
            children: []
        },

        { // 风控管理
            path: '/riskConfig',
            name: 'riskConfig',
            meta: { id: 98 },
            component: r => require.ensure([], () => r(require('@/page/business/riskManagement/riskManagement.vue')), 'schedulingTabs'),
        },
        { // 排班管理 - 定制客运
            path: '/customizeReporting',
            name: 'customizeReporting',
            meta: { id: 65, pid: 27, breadcrumb: [{ name: '线路排班', path: '/customize' }, { name: '线路报班' }] },
            component: r => require.ensure([], () => r(require('@/page/scheduling/customize/customizeReporting.vue')), 'customize'),
            children: []
        },
        { // 定制客运 线路信息
            path: '/dockingPoint',
            name: 'dockingPoint',
            meta: { id: 65, breadcrumb: [{ name: '线路管理', path: '/customize' }, { name: '线路信息' }] },
            component: r => require.ensure([], () => r(require('@/page/scheduling/customize/dockingPoint.vue')), 'customize'),
            children: []
        },
        { // 定制客运 排班管理
            path: '/schedulingForm',
            name: 'schedulingForm',
            meta: { id: 65, breadcrumb: [{ name: '排班管理', path: '/customize' }, { name: '排班信息' }] },
            component: r => require.ensure([], () => r(require('@/page/scheduling/customize/schedulingForm.vue')), 'customize'),
            children: []
        },
        { // 定制客运 排班模式-设置
            path: '/schedulingTypeForm',
            name: 'schedulingTypeForm',
            meta: { id: 65, breadcrumb: [{ name: '排班模式', path: '/customize' }, { name: '排班信息' }] },
            component: r => require.ensure([], () => r(require('@/page/scheduling/customize/schedulingTypeForm.vue')), 'customize'),
            children: []
        },
        { // 定制客运 排班设置-观察
            path: '/schedulingSetting',
            name: 'schedulingSetting',
            meta: { id: 65, breadcrumb: [{ name: '线路排班', path: '/customize' }, { name: '排班信息' }] },
            component: r => require.ensure([], () => r(require('@/page/scheduling/customize/schedulingSetting.vue')), 'customize'),
            children: []
        },
        { // 定制客运 排班设置-编辑
            path: '/schedulingSettingEdit',
            name: 'schedulingSettingEdit',
            meta: { id: 65, breadcrumb: [{ name: '线路排班', path: '/customize' }, { name: '排班信息' }] },
            component: r => require.ensure([], () => r(require('@/page/scheduling/customize/schedulingSettingEdit.vue')), 'customize'),
            children: []
        },

        { // 班线客运 排班设置-观察
            path: '/schedulingTimeForm',
            name: 'schedulingTimeForm',
            meta: { id: 66, breadcrumb: [{ name: '线路排班', path: '/line' }, { name: '排班信息' }] },
            component: r => require.ensure([], () => r(require('@/page/scheduling/line/schedulingTimeForm.vue')), 'line'),
            children: []
        },
        { // 班线客运 排班设置-编辑
            path: '/schedulingTimeFormEdit',
            name: 'schedulingTimeFormEdit',
            meta: { id: 66, breadcrumb: [{ name: '线路排班', path: '/line' }, { name: '排班信息' }] },
            component: r => require.ensure([], () => r(require('@/page/scheduling/line/schedulingTimeFormEdit.vue')), 'line'),
            children: []
        },

        { // 营销管理-广告管理
            path: '/bannerFrame',
            name: 'bannerFrame',
            redirect: '/banner',
            meta: { id: 22 },
            component: r => require.ensure([], () => r(require('@/page/marketing/banner/bannerFrame.vue')), 'banner'),
            children: [
                { // 顶部广告
                    path: '/advertising',
                    name: 'top',
                    meta: { id: 22 },
                    component: r => require.ensure([], () => r(require('@/page/marketing/banner/top/top.vue')), 'banner'),
                    children: []
                },
                { // 专题广告
                    path: '/topic',
                    name: 'topic',
                    meta: { id: 22 },
                    component: r => require.ensure([], () => r(require('@/page/marketing/banner/topic/topic.vue')), 'banner'),
                    children: []
                }, { // 轮播广告
                    path: '/carousel',
                    name: 'carousel',
                    meta: { id: 22 },
                    component: r => require.ensure([], () => r(require('@/page/marketing/banner/carousel/carousel.vue')), 'banner'),
                    children: []
                }, { // 贴纸广告
                    path: '/sticker',
                    name: 'sticker',
                    meta: { id: 22 },
                    component: r => require.ensure([], () => r(require('@/page/marketing/banner/sticker/sticker.vue')), 'banner'),
                    children: []
                }]
        },

        { // 营销管理-轮播广告-新增/编辑
            path: '/recommendedLine',
            name: 'recommendedLine',
            meta: { id: 37 },
            component: r => require.ensure([], () => r(require('@/page/recommendedLine/recommendedLine.vue')), 'recommendedLine'),
            children: []
        },
        { // 营销管理-专题广告-新增/编辑
            path: '/topicForm',
            name: 'topicForm',
            meta: { id: 22, breadcrumb: [{ name: '专题广告', path: '/advertising' }, { name: '广告信息' }] },
            component: r => require.ensure([], () => r(require('@/page/marketing/banner/topic/topicForm.vue')), 'banner'),
            children: []
        },
        { // 营销管理-轮播广告-新增/编辑
            path: '/carouselForm',
            name: 'carouselForm',
            meta: { id: 22, breadcrumb: [{ name: '轮播广告', path: '/carousel' }, { name: '广告信息' }] },
            component: r => require.ensure([], () => r(require('@/page/marketing/banner/carousel/carouselForm.vue')), 'banner'),
            children: []
        },
        { // 营销管理-贴纸广告-新增/编辑
            path: '/stickerForm',
            name: 'stickerForm',
            meta: { id: 22, breadcrumb: [{ name: '贴纸广告', path: '/sticker' }, { name: '广告信息' }] },
            component: r => require.ensure([], () => r(require('@/page/marketing/banner/sticker/stickerForm.vue')), 'banner'),
            children: []
        },
        { // 营销管理-贴纸广告-新增/编辑
            path: '/workbench',
            name: 'workbench',
            meta: { id: 36 },
            component: r => require.ensure([], () => r(require('../page/workbench/workbench.vue')), 'workbench'),
            children: []
        },
        { // 营销管理-优惠券管理
            path: '/couponFrame',
            name: 'couponFrame',
            redirect: '/coupon',
            meta: { id: 28 },
            component: r => require.ensure([], () => r(require('@/page/marketing/coupon/couponFrame.vue')), 'marketing'),
            children: [{ // 营销管理-优惠券管理
                path: '/coupon',
                name: 'coupon',
                meta: { id: 28 },
                component: r => require.ensure([], () => r(require('@/page/marketing/coupon/coupon.vue')), 'marketing'),
                children: []
            }, { // 营销管理-优惠券管理
                path: '/couponReceiving',
                name: 'couponReceiving',
                meta: { id: 28 },
                component: r => require.ensure([], () => r(require('@/page/marketing/coupon/couponReceiving.vue')), 'marketing'),
                children: []
            },]
        },
        { // 营销管理-优惠券管理-新增/编辑
            path: '/couponForm',
            name: 'couponForm',
            meta: { id: 28, breadcrumb: [{ name: '优惠券管理', path: '/coupon' }, { name: '优惠券信息' }] },
            component: r => require.ensure([], () => r(require('@/page/marketing/coupon/couponForm.vue')), 'carouselForm'),
            children: []
        },
        { // 营销管理-活动管理
            path: '/marketingActivity',
            name: 'marketingActivity',
            meta: { id: 133 },
            component: r => require.ensure([], () => r(require('@/page/marketing/activity/list.vue')), 'marketing'),
            children: []
        },

        {
            path: '/organization',
            name: 'organization',
            meta: { id: 32 },
            component: r => require.ensure([], () => r(require('../page/system/organization/organization.vue')), 'system'),
            children: []
        },
        {
            path: '/organizationForm',
            name: 'organizationForm',
            meta: { id: 32, breadcrumb: [{ name: '机构名称', path: '/organization' }, { name: '分机构信息' }] },
            component: r => require.ensure([], () => r(require('@/page/system/organization/organizationForm.vue')), 'system'),
            children: []
        },
        {
            path: '/organizationMessage',
            name: 'organizationMessage',
            meta: { id: 32, breadcrumb: [{ name: '机构名称', path: '/organization' }, { name: '合规信息' }] },
            component: r => require.ensure([], () => r(require('@/page/system/organization/organizationMessage.vue')), 'system'),
            children: []
        },
        {
            path: '/organizationMessageBranch',
            name: 'organizationMessageBranch',
            meta: { id: 32, breadcrumb: [{ name: '机构名称', path: '/organization' }, { name: '分公司合规信息' }] },
            component: r => require.ensure([], () => r(require('@/page/system/organization/organizationMessageBranch.vue')), 'system'),
            children: []
        },
        {
            path: '/cooperateInfo',
            name: 'cooperateInfo',
            meta: { id: 32, breadcrumb: [{ name: '机构名称', path: '/organization' }, { name: '合作信息' }] },
            component: r => require.ensure([], () => r(require('@/page/system/organization/cooperateInfo.vue')), 'system'),
            children: []
        },
        {
            path: '/ai',
            name: 'ai',
            redirect: '/aiCard',
            meta: { id: 38 },
            component: r => require.ensure([], () => r(require('../page/system/ai/ai.vue')), 'system'),
            children: [
                {
                    path: '/aiCard',
                    name: 'aiCard',
                    meta: { id: 38, },
                    component: r => require.ensure([], () => r(require('@/page/system/ai/aiCard.vue')), 'system'),
                    children: []
                },
                {
                    path: '/aiConfig',
                    name: 'aiConfig',
                    meta: { id: 38, },
                    component: r => require.ensure([], () => r(require('@/page/system/ai/aiConfig.vue')), 'system'),
                    children: []
                },

            ]
        },
        {
            path: '/costCenter',
            name: 'costCenter',
            meta: { id: 42 },
            component: r => require.ensure([], () => r(require('../page/system/costCenter/costCenter.vue')), 'system'),
            children: []
        },
        {
            path: '/log',
            name: 'log',
            meta: { id: 30 },
            component: r => require.ensure([], () => r(require('@/page/system/log/log.vue')), 'system'),
            children: []
        },

        { // 系统设置-后台账号
            path: '/backgroundAccount',
            name: 'backgroundAccount',
            redirect: '/member',
            meta: { id: 10 },
            component: r => require.ensure([], () => r(require('@/page/system/backgroundAccount/backgroundAccount.vue')), 'backgroundAccount'),
            children: [
                {
                    path: '/member',
                    name: 'member',
                    meta: { id: 10 },
                    component: r => require.ensure([], () => r(require('@/page/system/backgroundAccount/member/member.vue')), 'backgroundAccount'),
                    children: []
                },
                {
                    path: '/role',
                    name: 'role',
                    meta: { id: 10 },
                    component: r => require.ensure([], () => r(require('@/page/system/backgroundAccount/role/role.vue')), 'backgroundAccount'),
                    children: []
                },
                { // 系统设置-菜单管理
                    path: '/menuManage',
                    name: 'menuManage',
                    meta: { id: 207 },
                    component: r => require.ensure([], () => r(require('@/page/system/menuManage/menuManage.vue')), 'menuManage'),
                    children: []
                }
            ]
        },
        {
            path: '/roleForm',
            name: 'roleForm',
            meta: { id: 10, breadcrumb: [{ name: '角色权限', path: '/role' }, { name: '角色信息' }] },
            component: r => require.ensure([], () => r(require('@/page/system/backgroundAccount/role/roleForm.vue')), 'backgroundAccount'),
            children: []
        },
        {// 个人中心
            path: '/myProfile',
            name: 'myProfile',
            meta: { id: 0 },
            component: r => require.ensure([], () => r(require('@/page/system/myProfile/myProfile.vue')), 'myProfile'),
            children: []
        },
        {// 系统设置-安检员账号
            path: '/inspector',
            name: 'inspector',
            meta: { id: 49 },
            component: r => require.ensure([], () => r(require('@/page/system/inspector/inspector.vue')), 'inspector'),
            children: []
        },
        {// 系统设置-背景审核
            path: '/hitchRideAdverseRecord',
            name: 'hitchRideAdverseRecord',
            meta: { id: 107 },
            component: r => require.ensure([], () => r(require('@/page/system/adverseRecord/frame.vue')), 'hitchRideAdverseRecord'),
            children: []
        },
        { // 系统设置-短信管理
            path: '/sms',
            name: 'sms',
            redirect: '/smsTemplate',
            meta: { id: 23 },
            component: r => require.ensure([], () => r(require('@/page/system/sms/sms.vue')), 'sms'),
            children: [{ // 系统设置-短信管理
                path: '/smsTemplate',
                name: 'smsTemplate',
                meta: { id: 23 },
                component: r => require.ensure([], () => r(require('@/page/system/sms/smsTemplate.vue')), 'sms'),
                children: []
            },
            { // 系统设置-短信记录
                path: '/smsRecord',
                name: 'smsRecord',
                meta: { id: 23 },
                component: r => require.ensure([], () => r(require('@/page/system/sms/smsRecord.vue')), 'sms'),
                children: []
            },
            { // 系统设置-短信记录
                path: '/smsConfig',
                name: 'smsConfig',
                meta: { id: 23 },
                component: r => require.ensure([], () => r(require('@/page/system/sms/smsConfig.vue')), 'sms'),
                children: []
            },
            { // 系统设置-短信记录
                path: '/smsRecord',
                name: 'smsRecord',
                meta: { id: 23 },
                component: r => require.ensure([], () => r(require('@/page/system/sms/smsRecord.vue')), 'sms'),
                children: []
            },
            { // 系统设置-短信统计
                path: '/smsStatistics',
                name: 'smsStatistics',
                meta: { id: 23 },
                component: r => require.ensure([], () => r(require('@/page/system/sms/smsStatistics.vue')), 'sms'),
                children: []
            }
            ]
        },

        // 场站
        { //运营中心-线路管理
            path: '/czLine',
            name: 'czLine',
            meta: { id: 109 },
            component: r => require.ensure([], () => r(require('@/page/business_changzhan/operate/line/line.vue')), 'business_changzhan'),
            children: []
        },
        { //运营中心-发车场站
            path: '/airportStart',
            name: 'airportStart',
            meta: { id: 110 },
            component: r => require.ensure([], () => r(require('@/page/business_changzhan/operate/departureStation/list.vue')), 'business_changzhan'),
            children: []
        },
        { //线路编辑
            path: '/czLineEdit',
            name: 'czLineEdit',
            meta: { id: 109, breadcrumb: [{ name: '线路管理', path: '/czLine' }, { name: '线路信息' }] },
            component: r => require.ensure([], () => r(require('@/page/business_changzhan/operate/line/lineEdit.vue')), 'business_changzhan'),
            children: []
        },
        { //系统设置-员工账号
            path: '/czAccount',
            name: 'czAccount',
            meta: { id: 114 },
            component: r => require.ensure([], () => r(require('@/page/business_changzhan/system/czAccount/czAccount.vue')), 'business_changzhan'),
            children: []
        },

        { //文旅-预约确认
            path: '/travelReservationSure',
            name: 'travelReservationSure',
            meta: { id: 126 },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/reservation/sure.vue')), 'business_lvyou'),
            children: []
        },

        // 文旅
        { //文旅-线路管理
            path: '/travelLine',
            name: 'travelLine',
            meta: { id: 122 },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/line/list.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-线路编辑
            path: '/ly_lineEdit',
            name: 'ly_lineEdit',
            meta: { id: 122, type: 'content', breadcrumb: [{ name: '文旅线路', path: '/travelLine' }, { name: '线路信息' }] },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/line/edit.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-线路车辆
            path: '/ly_lineVehicle',
            name: 'ly_lineVehicle',
            meta: { id: 122, breadcrumb: [{ name: '文旅线路', path: '/travelLine' }, { name: '值班车辆' }] },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/line/vehicle.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-线路商品
            path: '/travelGoods',
            name: 'travelGoods',
            meta: { id: 127 },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/goods/list.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-线路商品-编辑
            path: '/ly_goodsEdit',
            name: 'ly_goodsEdit',
            meta: { id: 127, type: 'content', breadcrumb: [{ name: '商品管理', path: '/travelGoods' }, { name: '编辑商品' }] },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/goods/edit.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-线路商品-创建
            path: '/ly_goodsCreate',
            name: 'ly_goodsCreate',
            meta: { id: 127, type: 'content', breadcrumb: [{ name: '商品管理', path: '/travelGoods' }, { name: '创建商品' }] },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/goods/edit.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-线路商品-库存
            path: '/ly_goodsInventory',
            name: 'ly_goodsInventory',
            meta: { id: 127, breadcrumb: [{ name: '商品管理', path: '/travelGoods' }, { name: '库存管理' }] },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/goods/inventory.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-行程预约-选择商品
            path: '/travelReservation',
            name: 'travelReservation',
            meta: { id: 125 },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/reservation/chooseGoods.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-行程预约
            path: '/travelReservationForm',
            name: 'travelReservationForm',
            meta: { id: 125 },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/reservation/reservation.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-预约列表
            path: '/travelReservationManager',
            name: 'travelReservationManager',
            meta: { id: 126 },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/reservation/list.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-预约详情
            path: '/travelReservationDetail',
            name: 'travelReservationDetail',
            meta: { id: 126, breadcrumb: [{ name: '预约管理', path: '/travelReservationManager' }, { name: '预约详情' }] },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/reservation/detail.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-订单管理
            path: '/travelOrder',
            name: 'travelOrder',
            meta: { id: 128 },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/order/list.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-订单详情
            path: '/travelOrderDetail',
            name: 'travelOrderDetail',
            meta: { id: 128, breadcrumb: [{ name: '订单管理', path: '/travelOrder' }, { name: '订单详情' }] },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/order/detail.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-行程管理
            path: '/travelItinerary',
            name: 'travelItinerary',
            meta: { id: 123 },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/trip/list.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-行程详情
            path: '/travelSchedulingDetail',
            name: 'travelSchedulingDetail',
            meta: { id: 123, breadcrumb: [{ name: '行程管理', path: '/travelItinerary' }, { name: '行程详情' }] },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/trip/detail.vue')), 'business_lvyou'),
            children: []
        },

        { //文旅-酒店管理
            path: '/travelHotel',
            name: 'travelHotel',
            meta: { id: 208 },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/hotel/list.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-酒店-创建
            path: '/ly_hotelCreate',
            name: 'ly_hotelCreate',
            meta: { id: 208, type: 'content', breadcrumb: [{ name: '酒店管理', path: '/travelHotel' }, { name: '创建酒店' }] },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/hotel/edit.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-酒店-编辑
            path: '/ly_hotelEdit',
            name: 'ly_hotelEdit',
            meta: { id: 208, type: 'content', breadcrumb: [{ name: '酒店管理', path: '/travelHotel' }, { name: '编辑酒店' }] },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/hotel/edit.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-酒店-房型管理
            path: '/ly_hotelRoom',
            name: 'ly_hotelRoom',
            meta: { id: 208, breadcrumb: [{ name: '酒店管理', path: '/travelHotel' }, { name: '房型管理' }] },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/hotel/room.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-景区管理
            path: '/travelScenic',
            name: 'travelScenic',
            meta: { id: 209 },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/scenic/list.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-景区-创建
            path: '/ly_scenicCreate',
            name: 'ly_scenicCreate',
            meta: { id: 209, type: 'content', breadcrumb: [{ name: '景区管理', path: '/travelScenic' }, { name: '创建景区' }] },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/scenic/edit.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-景区-编辑
            path: '/ly_scenicEdit',
            name: 'ly_scenicEdit',
            meta: { id: 209, type: 'content', breadcrumb: [{ name: '景区管理', path: '/travelScenic' }, { name: '编辑景区' }] },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/scenic/edit.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-景区-票种管理
            path: '/ly_scenicTicket',
            name: 'ly_scenicTicket',
            meta: { id: 209, breadcrumb: [{ name: '景区管理', path: '/travelScenic' }, { name: '票种管理' }] },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/scenic/ticket.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-行程模板管理
            path: '/travelItineraryTemplate',
            name: 'travelItineraryTemplate',
            meta: { id: 210 },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/itinerary/list.vue')), 'business_lvyou'),
            children: []
        },
        { //文旅-行程模板-编辑
            path: '/ly_itineraryEdit',
            name: 'ly_itineraryEdit',
            meta: { id: 210, type: 'content', breadcrumb: [{ name: '行程模板', path: '/travelItineraryTemplate' }, { name: '编辑模板' }] },
            component: r => require.ensure([], () => r(require('@/page/business_lvyou/itinerary/edit.vue')), 'business_lvyou'),
            children: []
        },

        // 渠道管理
        { // 渠道管理
            path: '/channelManage',
            name: 'channelManage',
            meta: { id: 200 },
            component: r => require.ensure([], () => r(require('@/page/channel/channelTabs.vue')), 'channel'),
            children: [
                { // 渠道审核
                    path: '/channelAudit',
                    name: 'channelAudit',
                    meta: { id: 201, pid: 200 },
                    component: r => require.ensure([], () => r(require('@/page/channel/audit/channelAudit.vue')), 'channel'),
                    children: []
                },
                { // 渠道列表
                    path: '/channelList',
                    name: 'channelList',
                    meta: { id: 202, pid: 200 },
                    component: r => require.ensure([], () => r(require('@/page/channel/list/channelList.vue')), 'channel'),
                    children: []
                },
                { // 佣金配置
                    path: '/channelCommission',
                    name: 'channelCommission',
                    meta: { id: 203, pid: 200 },
                    component: r => require.ensure([], () => r(require('@/page/channel/commission/channelCommission.vue')), 'channel'),
                    children: []
                },
                { // 提现管理
                    path: '/channelWithdrawal',
                    name: 'channelWithdrawal',
                    meta: { id: 204, pid: 200 },
                    component: r => require.ensure([], () => r(require('@/page/channel/withdrawal/channelWithdrawal.vue')), 'channel'),
                    children: []
                },
                { // 渠道订单
                    path: '/channelOrder',
                    name: 'channelOrder',
                    meta: { id: 205, pid: 200 },
                    component: r => require.ensure([], () => r(require('@/page/channel/order/channelOrder.vue')), 'channel'),
                    children: []
                },
                { // 渠道财务
                    path: '/channelFinancial',
                    name: 'channelFinancial',
                    meta: { id: 206, pid: 200 },
                    component: r => require.ensure([], () => r(require('@/page/channel/financial/channelFinancial.vue')), 'channel'),
                    children: []
                }
            ]
        },
        { // 渠道详情
            path: '/channelDetail',
            name: 'channelDetail',
            meta: { id: 202, breadcrumb: [{ name: '渠道管理', path: '/channelList' }, { name: '渠道详情' }] },
            component: r => require.ensure([], () => r(require('@/page/channel/detail/channelDetail.vue')), 'channel'),
            children: []
        },

        // 协议中心
        { // 协议中心-协议管理
            path: '/protocolManage',
            name: 'protocolManage',
            meta: { id: 214 },
            component: r => require.ensure([], () => r(require('@/page/protocolCenter/protocolManage.vue')), 'protocolCenter'),
            children: []
        },
        { // 协议中心-协议记录
            path: '/protocolRecord',
            name: 'protocolRecord',
            meta: { id: 215 },
            component: r => require.ensure([], () => r(require('@/page/protocolCenter/protocolRecord.vue')), 'protocolCenter'),
            children: []
        },

        // 数据分析
        { // 数据分析-用户端分析
            path: '/userBehaviorAnalysis',
            name: 'userBehaviorAnalysis',
            meta: { id: 0 },
            component: r => require.ensure([], () => r(require('@/page/dataAnalysis/userBehavior/userBehaviorAnalysis.vue')), 'dataAnalysis'),
            children: []
        },

    ]
}
]

export default new Router({
    routes
})
